
import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthProvider/AuthProvider';
import { toast } from 'react-hot-toast';
import { useState } from 'react';
const SingUp = () => {
  const {createUer} = useContext(AuthContext)
  const navigate = useNavigate();
  const [error, setError] = useState('')
    const handleSignUp = event=>{
        event.preventDefault();
        const form = event.target;
      const email = form.email.value;
        const password = form.password.value;
        console.log(email,password);
        if(!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9_])/.test(password)){
         return  setError('Use uppsercase,lowercase,number and sepecial charecter in password')
        }
        createUer(email,password)
        .then(result=>{
          const user = result.user;
          toast.success('User created')
          navigate('/');
          console.log(user);
        })
        .catch(err=>console.log(err))
    }
    return (
        <div className="hero w-full my-4">
        <div className="hero-content flex-col">
          <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
            <form  onSubmit={handleSignUp} className="card-body">
            <h1 className="text-5xl font-bold">Register</h1>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Name</span>
                </label>
                <input type="text" placeholder="Your name" className="input input-bordered" />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Email</span>
                </label>
                <input type="text" placeholder="email" name='email' className="input input-bordered" />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Password</span>
                </label>
                <input type="text" name='password' placeholder="password" className="input input-bordered" />
              </div>
              <div className="form-control mt-6">
                <input type="submit" className='btn btn-success' value="Submit" />
              </div>
            </form>
            <p className='text-red-500 font-small text-center'>{error}</p>
            <p className='text-center px-24 py-4'>Already have an account? <Link className='text-orange-700' to={'/login'}>Login</Link> </p>
          </div>
        </div>
      </div>
    );
};

export default SingUp;